import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from '@core/services/auth/auth.service';
import { LocalStorageService } from '@core/services/local-storage/local-storage.service';
import { NgIdleService } from '@core/services/user-idle-manager/ng-idle.service';

@Component({
  selector: 'Teranet-SessionDialog',
  templateUrl: './session-dialog.component.html',
  providers: [NgIdleService]
})

export class SessionDialogComponent {
  idleState = 0;

  constructor(public idle: NgIdleService,
    public authService: AuthService,
    public dialogRef: MatDialogRef<SessionDialogComponent>,
    private localStorageService: LocalStorageService,
    @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  onNoClick(): void {
    this.dialogRef.close({ data: 'reset' });
  }

  get leftTime(): number {
    return this.localStorageService.getItem("timeLeft") ? Number(this.localStorageService.getItem("timeLeft")) : 0;
  }

}
